import React from "react";
import ProductHotspotInfo from "./hotspot/ProductHotspotInfo";
import MobileContainer from "./hotspot/MobileHotspotContainer";

/**
 *
 * @param props {{data: object}}
 * @returns {JSX.Element}
 */
export default ({ data }) => {
  const {
    api: { imageSrc, hotspots },
  } = data;
  return (
    <>
      <div className="d-none d-lg-block">
        <ProductHotspotInfo hotspots={hotspots} imageSrc={imageSrc} />
      </div>
      <div className="d-lg-none">
        <MobileContainer {...data} />
      </div>
    </>
  );
};
